"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Column_1 = __importDefault(require("../Column"));
var Row_1 = __importDefault(require("../Row"));
var SumCannabinoidsCard_1 = __importDefault(require("../SumCannabinoidsCard"));
var TotalCannabinoidsCard_1 = __importDefault(require("../TotalCannabinoidsCard"));
var TotalCbdCard_1 = __importDefault(require("../TotalCbdCard"));
var TotalThcCard_1 = __importDefault(require("../TotalThcCard"));
var renderer_1 = require("@react-pdf/renderer");
var Card_1 = __importDefault(require("../Card"));
var utils_1 = require("../../utils");
var calculations_1 = require("../../utils/calculations");
var StandardCalloutsSection = function (_a) {
    var cannabinoidsPanelResult = _a.cannabinoidsPanelResult, terpenesPanelResult = _a.terpenesPanelResult, moistureContentPercentage = _a.moistureContentPercentage, density = _a.density, waterActivity = _a.waterActivity, parameters = _a.parameters, _b = _a.ThcCardComponent, ThcCardComponent = _b === void 0 ? TotalThcCard_1.default : _b;
    var sumTerpenes = calculations_1.deriveSumTerpenes(terpenesPanelResult);
    return (React.createElement(React.Fragment, null,
        React.createElement(Column_1.default, { style: { margin: 2.15 } },
            React.createElement(Row_1.default, null,
                React.createElement(Column_1.default, { style: { marginRight: 2.15 } },
                    React.createElement(ThcCardComponent, { cannabinoidsPanelResult: cannabinoidsPanelResult, moistureContentPercentage: moistureContentPercentage !== null && moistureContentPercentage !== void 0 ? moistureContentPercentage : 0, density: density, parameters: parameters })),
                React.createElement(Column_1.default, { style: { marginLeft: 2.15 } },
                    React.createElement(TotalCbdCard_1.default, { cannabinoidsPanelResult: cannabinoidsPanelResult, moistureContentPercentage: moistureContentPercentage !== null && moistureContentPercentage !== void 0 ? moistureContentPercentage : 0, density: density, parameters: parameters }))),
            React.createElement(Row_1.default, null,
                React.createElement(Column_1.default, { style: { marginRight: 2.15 } },
                    React.createElement(TotalCannabinoidsCard_1.default, { cannabinoidsPanelResult: cannabinoidsPanelResult, moistureContentPercentage: moistureContentPercentage !== null && moistureContentPercentage !== void 0 ? moistureContentPercentage : 0, density: density, parameters: parameters })),
                React.createElement(Column_1.default, { style: { marginLeft: 2.15 } },
                    React.createElement(SumCannabinoidsCard_1.default, { cannabinoidsPanelResult: cannabinoidsPanelResult, moistureContentPercentage: moistureContentPercentage !== null && moistureContentPercentage !== void 0 ? moistureContentPercentage : 0, density: density, parameters: parameters })))),
        React.createElement(Column_1.default, { style: { margin: 2.15 } },
            React.createElement(Row_1.default, null,
                React.createElement(Card_1.default, { style: {
                        display: "flex",
                        flexGrow: 1,
                        alignItems: "center",
                    } },
                    React.createElement(renderer_1.Text, { style: {
                            fontFamily: "Quicksand",
                            fontSize: 12,
                            fontWeight: 700,
                        } }, "Total Terpenes"),
                    React.createElement(renderer_1.Text, { style: {
                            fontFamily: "Quicksand",
                            fontSize: 12,
                            fontWeight: 700,
                        } }, terpenesPanelResult
                        ? utils_1.displayMeasurmentAsPercent(sumTerpenes)
                        : "NT"),
                    React.createElement(renderer_1.View, { style: {
                            width: "100%",
                            borderBottom: 1,
                            borderColor: "#e1e1e1",
                            marginVertical: 8,
                        } }),
                    React.createElement(renderer_1.Text, { style: {
                            fontFamily: "Quicksand",
                            fontSize: 12,
                            fontWeight: 700,
                        } }, "Water Activity"),
                    React.createElement(renderer_1.Text, { style: {
                            fontFamily: "Quicksand",
                            fontSize: 12,
                            fontWeight: 700,
                        } }, (function () {
                        if (typeof waterActivity === "number") {
                            return (React.createElement(React.Fragment, null,
                                waterActivity.toFixed(4),
                                "a",
                                React.createElement(renderer_1.Text, { style: { fontSize: 8 } }, "w")));
                        }
                        return waterActivity;
                    })()),
                    React.createElement(renderer_1.View, { style: {
                            width: "100%",
                            borderBottom: 1,
                            borderColor: "#e1e1e1",
                            marginVertical: 8,
                        } }),
                    React.createElement(renderer_1.Text, { style: {
                            fontFamily: "Quicksand",
                            fontSize: 12,
                            fontWeight: 700,
                        } }, "Moisture Content"),
                    React.createElement(renderer_1.Text, { style: {
                            fontFamily: "Quicksand",
                            fontSize: 12,
                            fontWeight: 700,
                        } }, moistureContentPercentage === undefined
                        ? "NT"
                        : moistureContentPercentage.toFixed(2) + "%"))))));
};
exports.default = StandardCalloutsSection;
//# sourceMappingURL=index.js.map